// extracted by mini-css-extract-plugin
module.exports = {"viewToggle":"ViewToggle_viewToggle__1xja1","viewName":"ViewToggle_viewName__3l1cp","viewToggleButtonContainer":"ViewToggle_viewToggleButtonContainer__26I03"};